import type { FormRules } from 'element-plus';
import { validatePassword } from './validator';

export function validatePasswordRule(
  rule: any,
  value: string,
  callback: (error?: string | Error) => void
): void {
  if (!value) {
    return callback();
  }

  if (!validatePassword(value)) {
    return callback(new Error());
  }

  callback();
}